import translation from 'locales/translation';
import { Grid, Typography } from '@material-ui/core';
import Breadcrumb, {
  IBreadCrumbItem,
} from 'components/__ASSESSOR__/BreadCrumb/BreadCrumb';
import {
  BlockIcon,
  CircleIcCheck,
  List,
  LockIcon,
  PeopleIcon,
  PeopleTie,
  RestritoIcon,
  SyncIcon,
  ThreeDots,
} from 'components/Icons';
import AbrirVotacaoPautaModal, {
  IAbrirVotacaoPautaModalGenericProps,
} from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/AbrirVotacaoPautaModal';
import Page from 'components/__SHARED__/PrivateContainer';
import { AssembleiaTipoPauta } from 'helpers/enums/AssembleiaPautaStatus';
import { AssembleiaStatus } from 'helpers/enums/AssembleiaStatus';
import { AssembleiaTipo } from 'helpers/enums/AssembleiaTipo';
import { AssembleiaAssessorRoutePath, AssessorRoutePath } from 'library/Routes';
import {
  Button,
  ButtonThemes,
  Col,
  DropdownItem,
  DropdownMenu,
  IconButton,
  LeftCheckboxWithLabel,
  Row,
  Select,
  Table,
  Title,
} from 'plataforma-fundacao-componentes';
import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { IReducer } from 'store/Reducer';
import { history } from 'store/Store';
import { modalsActionsOpen } from 'store/modules/ModalsActions';
import {
  PautasEmLoteType,
  assessorFilterByType,
} from 'store/modules/assessor/actions';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import dotsOnLargeText from 'helpers/utils/dotsOnLargeText';
import Context from '../../Context';
import useStyle from '../../style';

export default function LiberarPautasEmLote() {
  const [value, setValue] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selecionados, setSelecionados] = useState<any>([]);
  const selecionadosRef = useRef(selecionados);
  selecionadosRef.current = selecionados;
  const [pautasFiltradas, setPautasFiltradas] = useState<PautasEmLoteType[]>(
    []
  );
  const { evento, liberarEmLote, loadingEvento } = useContext(Context);
  const dispatchAction = useDispatch();
  const { quantasVezesRecebemosPautasNovas } = useSelector(
    (state: IReducer) => state.assessor
  );

  const [valueFix, setValueFix] = useState<Number[]>();

  const [dropOpened, setDropOpened] = useState<any>(undefined);

  const toggleDropOpened = (reference: any, value: any) => {
    if (value) {
      setDropOpened(reference);
    } else if (dropOpened === reference) {
      setDropOpened(undefined);
    }
  };

  const isAGN = useMemo(() => {
    if (!evento?.tipo) return false;
    return [AssembleiaTipo.Nucleo, AssembleiaTipo.Reuniao].includes(
      evento.tipo
    );
  }, [evento]);

  const classes = useStyle({ isAGN });

  const filterPautas = (filter: any[]) => {
    setLoading(true);
    if (filter.length) {
      dispatchAction(
        assessorFilterByType(
          evento!?.id,
          filter,
          (response) => {
            setPautasFiltradas(response);
            setLoading(false);
          },
          (evt: any) => {
            ErrorHandler(evt);
            setLoading(false);
          }
        )
      );
    } else {
      setPautasFiltradas([]);
      setLoading(false);
    }
  };

  const selectedValues = useMemo(() => {
    if (selecionados.length && dropOpened) {
      return [dropOpened];
    } else if (selecionados.length && !dropOpened) {
      return selecionados;
    } else {
      if (dropOpened !== undefined) {
        setValueFix(dropOpened);
      }

      return valueFix;
    }
  }, [valueFix, dropOpened, selecionados]);

  const abrirVotacao = useCallback(() => {
    const modalKey: string = getUniqueKey();

    dispatchAction(
      modalsActionsOpen(
        AbrirVotacaoPautaModal,
        {
          genericProps: {
            key: modalKey,
            emLote: true,
            idEvento: evento!.id,
            pautas:
              typeof selectedValues === 'number'
                ? [selectedValues]
                : selectedValues,
            onSend: () => {
              toast.success('Pauta liberada com sucesso');
              setSelecionados([]);
            },
            close: () => {
              setValueFix([]);
            },
          } as IAbrirVotacaoPautaModalGenericProps,
        },
        modalKey
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    valueFix,
    selectedValues,
    dispatchAction,
    dropOpened,
    evento,
    selecionados,
  ]);

  useEffect(() => {
    setSelecionados([]);
    setValue([]);
    return () => {
      setPautasFiltradas([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [liberarEmLote]);

  useEffect(() => {
    if (liberarEmLote === true && evento) {
      dispatchAction(
        assessorFilterByType(
          evento.id,
          value,
          (response) => {
            setPautasFiltradas(response);
          },
          ErrorHandler
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evento]);

  const breadcrumb = useMemo(
    (): IBreadCrumbItem[] => [
      { nome: translation.MainRoute.title, url: AssessorRoutePath },
      {
        nome: loadingEvento
          ? translation.AssembleiaAssessorRoute.carregando
          : evento!.nome,
        url: `${AssembleiaAssessorRoutePath.replace(
          ':id',
          String(evento?.id)
        )}`,
      },
      { nome: translation.LiberarPautasEmLote.title },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loadingEvento, evento]
  );

  useEffect(() => {
    filterPautas(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantasVezesRecebemosPautasNovas]);

  useEffect(() => {
    if (selecionadosRef.current && selecionadosRef.current.length) {
      setSelecionados(
        [...selecionadosRef.current].filter((id) =>
          pautasFiltradas.some((p) => p.id === id)
        )
      );
    }
  }, [pautasFiltradas]);

  return (
    <Fragment>
      <Page
        header={
          <React.Fragment>
            <Title
              showBackButton
              onBackClick={() => {
                history.push(
                  `${AssembleiaAssessorRoutePath.replace(
                    ':id',
                    String(evento?.id)
                  )}`
                );
              }}
            >
              {translation.LiberarPautasEmLote.title}
            </Title>
            <Breadcrumb itens={breadcrumb} />
          </React.Fragment>
        }
        headerClassName={classes.header}
        contentClassName={classes.content}
      >
        <Row>
          <Col>
            <Typography
              component='h1'
              className={classes.subtitleLiberarEmLote}
            >
              {translation.AssembleiaAssessorRoute.liberarEmLote.subTitle}
            </Typography>
          </Col>
          <Col>
            <Select
              label={
                translation.AssembleiaAssessorRoute.liberarEmLote.selectLabel
              }
              placeholder={
                translation.AssembleiaAssessorRoute.liberarEmLote
                  .selectPlaceholder
              }
              multiple
              options={[
                {
                  label:
                    translation.AssembleiaAssessorRoute.liberarEmLote.table
                      .option1,
                  value: AssembleiaTipoPauta.Normal,
                },
                {
                  label:
                    translation.AssembleiaAssessorRoute.liberarEmLote.table
                      .option2,
                  value: AssembleiaTipoPauta.Eleicao,
                },
                {
                  label:
                    translation.AssembleiaAssessorRoute.liberarEmLote.table
                      .option3,
                  value: AssembleiaTipoPauta.Coordenador,
                },
              ]}
              onChange={(evt) => {
                setSelecionados([]);
                setValue(evt);
                filterPautas(evt);
              }}
              value={value}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Grid style={{ width: '100%' }}>
              <div className={classes.tableSection}>
                {value && value.length ? (
                  <Table
                    columns={[
                      {
                        key: 'checkbox',
                        value: (
                          <LeftCheckboxWithLabel
                            label={
                              translation.AssembleiaAssessorRoute.liberarEmLote
                                .tipoPauta
                            }
                            value={
                              Boolean(selecionados!?.length) &&
                              selecionados!?.length === pautasFiltradas!?.length
                            }
                            onChange={(val) => {
                              if (val) {
                                setSelecionados(
                                  pautasFiltradas!?.map((a: any) => a.id)
                                );
                              } else {
                                setSelecionados([]);
                              }
                            }}
                          />
                        ),
                      },
                      {
                        key: 'detalhes',
                        value:
                          translation.AssembleiaAssessorRoute.liberarEmLote
                            .table.header1,
                      },
                      {
                        key: 'agencia',
                        value:
                          translation.AssembleiaAssessorRoute.liberarEmLote
                            .table.header2,
                      },
                      {
                        key: 'nucleo',
                        value:
                          translation.AssembleiaAssessorRoute.liberarEmLote
                            .table.header3,
                      },
                      {
                        key: 'titulo',
                        value:
                          translation.AssembleiaAssessorRoute.liberarEmLote
                            .table.header4,
                      },
                      {
                        key: 'status',
                        value:
                          translation.AssembleiaAssessorRoute.liberarEmLote
                            .table.header5,
                      },
                      { key: 'actions', value: '' },
                    ]}
                    lines={pautasFiltradas!
                      ?.filter(
                        (a: any) => !value.length || value.includes(a.tipo)
                      )
                      .map((a: any) => {
                        return {
                          checkbox: (
                            <LeftCheckboxWithLabel
                              label={
                                (
                                  <div
                                    className={
                                      `${classes.badgeDetails}` +
                                      `${
                                        a.tipo === AssembleiaTipoPauta.Normal
                                          ? ' padrao'
                                          : a.tipo ===
                                            AssembleiaTipoPauta.Coordenador
                                          ? ' coordenador'
                                          : a.tipo ===
                                            AssembleiaTipoPauta.Eleicao
                                          ? ' conselho'
                                          : ''
                                      }`
                                    }
                                  >
                                    <span>
                                      {a.tipo === AssembleiaTipoPauta.Normal ? (
                                        <>
                                          <List />
                                          {
                                            translation.AssembleiaAssessorRoute
                                              .liberarEmLote.pautaPadrao
                                          }
                                        </>
                                      ) : a.tipo ===
                                        AssembleiaTipoPauta.Coordenador ? (
                                        <>
                                          <PeopleTie />
                                          {
                                            translation.AssembleiaAssessorRoute
                                              .liberarEmLote.pautaCoordenador
                                          }
                                        </>
                                      ) : a.tipo ===
                                        AssembleiaTipoPauta.Eleicao ? (
                                        <>
                                          <PeopleIcon />
                                          {
                                            translation.AssembleiaAssessorRoute
                                              .liberarEmLote.pautaConselho
                                          }
                                        </>
                                      ) : (
                                        ''
                                      )}
                                    </span>
                                  </div>
                                ) as any
                              }
                              value={selecionados.indexOf(a.id) > -1}
                              onChange={(v) => {
                                let sel = [...selecionados];
                                if (v) {
                                  sel.push(a.id);
                                } else {
                                  sel = sel.filter((aa) => aa !== a.id);
                                }
                                setSelecionados(sel);
                              }}
                            />
                          ),
                          detalhes: (
                            <div className={classes.detalhesIcons}>
                              {a.secreta && <BlockIcon />}
                              {a.restrita && <RestritoIcon />}
                              {!a.restrita && !a.secreta && '-'}
                            </div>
                          ),
                          agencia: a.agencia,
                          nucleo: a.nucleo,
                          titulo: (
                            <div
                              style={{
                                width: '550px',
                                maxWidth: '550px',
                                textAlign: 'left',
                                overflow: 'hidden',
                                whiteSpace: 'break-spaces',
                              }}
                            >
                              {dotsOnLargeText(a.titulo, 130)}
                            </div>
                          ),
                          status: (
                            <div className={classes.badgeTable}>
                              {a.status === 'BLOQUEADA' && (
                                <span>
                                  <LockIcon />
                                  Bloqueada
                                </span>
                              )}
                            </div>
                          ),
                          actions: (
                            <div>
                              <DropdownMenu
                                opened={String(dropOpened) === String(a.id)}
                                setOpened={(value) =>
                                  toggleDropOpened(a.id, value)
                                }
                                content={
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <DropdownItem
                                      label={
                                        translation.AssembleiaAssessorRoute
                                          .liberarEmLote.dropDown.liberarPauta
                                      }
                                      onClick={() => {
                                        abrirVotacao();
                                      }}
                                    />
                                  </div>
                                }
                              >
                                <IconButton
                                  icon={<ThreeDots />}
                                  disabled={
                                    evento!.status !== AssembleiaStatus.Live ||
                                    ((evento!.tipo === 'AGO' ||
                                      evento!.tipo === 'AGE' ||
                                      evento!.tipo === 'AOE') &&
                                      !evento!.existeQuorum)
                                  }
                                  onClick={() => {
                                    toggleDropOpened(a.id, dropOpened !== a.id);
                                  }}
                                />
                              </DropdownMenu>
                            </div>
                          ),
                        };
                      })}
                    upperHeader={{
                      active: Boolean(selecionados!?.length),
                      buttons: [
                        {
                          icon: <CircleIcCheck size={12} />,
                          label:
                            translation.AssembleiaAssessorRoute.liberarEmLote
                              .table.upperHeaderLabel,
                          disabled: true,
                          onClick: () => {
                            abrirVotacao();
                          },
                        },
                      ],
                    }}
                  />
                ) : undefined}
              </div>
              <div className={classes.liberarVotacaoButton}>
                {value && value.length ? (
                  <Button
                    onClick={() => abrirVotacao()}
                    theme={ButtonThemes.Primary}
                    disabled={
                      loading ||
                      !selecionados?.length ||
                      evento!.status !== AssembleiaStatus.Live ||
                      ((evento!.tipo === 'AGO' ||
                        evento!.tipo === 'AGE' ||
                        evento!.tipo === 'AOE') &&
                        !evento!.existeQuorum)
                    }
                    leftIcon={
                      loading ? <SyncIcon animated /> : <CircleIcCheck />
                    }
                  >
                    {
                      translation.AssembleiaAssessorRoute.liberarEmLote
                        .buttonText
                    }
                  </Button>
                ) : undefined}
              </div>
            </Grid>
          </Col>
        </Row>
      </Page>
    </Fragment>
  );
}
